// extracted by mini-css-extract-plugin
module.exports = {"header":"WRHeader_header__8S_yX","margin":"WRHeader_margin__89gyW","slider":"WRHeader_slider__ww_3k","slideWrapper":"WRHeader_slideWrapper__sxZYk"};